import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import ChooseArbitratorInCaseInformation from "../Onboarding/ChooseArbitratorInCaseInformation";
import PropTypes from "prop-types";
import withSizes from "react-sizes";
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withRouter } from "react-router-dom";
import Button from '@material-ui/core/Button';
import leftIcon from '../../images/leftPointer.svg'
import ArbitratorAcceptRejectBox from '../NavTabs/ArbitratorAcceptRejectBox'
import ArbitratorAppointed from '../NavTabs/ArbitratorAppointed'
import SelectedArbitrators from '../../containers/NavTabs/SelectedArbitrators'

const styles = {
  card2: {
    alignItems: "center",
    align: "center",
    boxShadow: "none",
    border: "none",
    // height:'100%',
    // width:'100vw',
    // minHeight: 700,
    // minWidth: 725,
    // marginLeft:'auto',
    // marginRight: 'auto'
  },
  myClassname: {},
};

class ChooseArbitratorForCaseInformation extends Component {
  state = {
    height: "100%",
    width: "100vw",
    typeOfAccount:localStorage.getItem('typeOfAccount')
  };

  componentDidMount() {

    // setInterval(() => {
    //   this.setState({
    //     height: "100vh",
    //   });
    // }, 3000);
  }

  render() {
    const { classes, src } = this.props;
    // console.log("chatbot_admin_question caseId: " + this.props.caseId);
    // console.log("chatbot_admin_question __dirname : " + __dirname);

    var sevenDaysLaterTime = new Date(this.props.caseData.timestampForCaseProcedure)
    sevenDaysLaterTime.setDate(sevenDaysLaterTime.getDate() + 7);
    
    var now = new Date();
    var canChooseArbitrator = true;
    var responseTimestamp;
    
    if (this.props.caseData.response !== undefined){
      responseTimestamp = new Date(this.props.caseData.response.timestampForCaseProcedure)

      var threeDaysLaterTimeAfterResponse = new Date(this.props.caseData.response.timestampForCaseProcedure)
      threeDaysLaterTimeAfterResponse.setDate(threeDaysLaterTimeAfterResponse.getDate() + 3);
      
      if (now >= threeDaysLaterTimeAfterResponse){
        // canChooseArbitrator = false
      }

      if (this.props.caseData.requireAdminChooseArbitrator == true){
        // canChooseArbitrator = false
      }
      
      if (now < threeDaysLaterTimeAfterResponse){
          var inTn = setInterval(()=>{
              if (now >= threeDaysLaterTimeAfterResponse){
                  // canChooseArbitrator = false;
                  clearInterval(inTn)
              }
          })
      } 
    }
    else if (this.props.caseData.response == undefined){
      // console.log('now: '+now)
      // console.log('sevenDaysLaterTime: '+sevenDaysLaterTime)
        // if (now <= sevenDaysLaterTime){
          // canChooseArbitrator = false
        // }
    }

    let fileURL =
      "/odr/chatbot_admin_question.html?caseId=" + this.props.caseId;
 
      // if (this.state.typeOfAccount !== "admin" && 
      //     this.state.typeOfAccount !== "arbitrator" && 
      //     canChooseArbitrator && 
      //     this.props.caseData.arbitratorStatus !== 'true'){
      if (canChooseArbitrator && this.state.typeOfAccount !== 'admin' && this.state.typeOfAccount !== 'arbitrator'){
        if (this.props.isDesktop) {
          return (
            <div style={{ height: this.state.height, width: this.state.width, textAlign:'center' }}>
              <div style={{height:'100px', backgroundColor:'#6C0E21', verticalAlign:'center'}}>
              <Grid
                container
                direction="column"
                justify
                spacing={12}
                >
                    <Grid
                        item
                        // spacing={8}
                        md={2}
                        lg={2}
                        sm={2}
                        xs={2}
                        style={{marginTop:'30px'}}
                        >
                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{    textAlign: 'left',
                                                                                                color: 'white',
                                                                                                marginLeft: '30px',
                                                                                                fontWeight: 'bold',
                                                                                                fontSize: '16px',
                                                                                                float: 'left',
                                                                                                height: '100%',
                                                                                                verticalAlign: 'middle', }}>
                        <img style={{width:'13%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                    </Grid>
                    <Grid
                        item
                        // spacing={8}
                        md={12}
                        lg={12}
                        sm={12}
                        xs={12}
                        // style={{marginBottom:'10px'}}
                        >
                        <h3 style={{ marginTop:'-25px',color:'white', textAlign:'center', fontWeight:'bolder', wordWrap: 'breakWord', whiteSpace: 'normal', fontSize:'17px', fontFamily:'Times New Roman Georgia' }}>
                        {this.context.t('Appointment of Arbitrator')}
                    </h3>
                    </Grid>
              </Grid>
              </div>
              {/* <SelectedArbitrators/> */}
              <ChooseArbitratorInCaseInformation />
            </div>
          );
        } else {
          return (
            <div style={{ height: this.state.height, width: this.state.width, textAlign:'center'}}>
              <div style={{height:'100px', backgroundColor:'#6C0E21', verticalAlign:'center'}}>
              <Grid
                container
                direction="column"
                spacing={12}
                >
                    <Grid
                        item
                        // spacing={8}
                        md={2}
                        lg={2}
                        sm={2}
                        xs={2}
                        style={{marginTop:'30px'}}
                        >
                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{    textAlign: 'left',
                                                                                                color: 'white',
                                                                                                marginLeft: '30px',
                                                                                                fontWeight: 'bold',
                                                                                                fontSize: '16px',
                                                                                                float: 'left',
                                                                                                height: '100%',
                                                                                                verticalAlign: 'middle', }}>
                        <img style={{width:'13%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                    </Grid>
                    <Grid
                        item
                        // spacing={8}
                        md={12}
                        lg={12}
                        sm={12}
                        xs={12}
                        // style={{marginBottom:'10px'}}
                        >
                        <h3 style={{ marginTop:'-25px',color:'white', textAlign:'center', fontWeight:'bolder', wordWrap: 'breakWord', whiteSpace: 'normal', fontSize:'17px', fontFamily:'Times New Roman Georgia' }}>
                        {this.context.t('Appointment of Arbitrator')}
                    </h3>
                    </Grid>
              </Grid>
              </div>
              {/* <SelectedArbitrators/> */}
              <ChooseArbitratorInCaseInformation />
            </div>
          );
        }
      }
      else if (this.state.typeOfAccount == 'arbitrator' && this.props.caseData.arbitratorStatus == "waiting"){
        return(
          <div style={{ height: this.state.height, width: this.state.width, textAlign:'center' }}>
          <div style={{height:'100px', backgroundColor:'#6C0E21', verticalAlign:'center'}}>
          <Grid
          container
          direction="column"
          justifyCo
          spacing={12}
          >
              <Grid
                  item
                  // spacing={8}
                  md={2}
                  lg={2}
                  sm={2}
                  xs={2}
                  style={{marginTop:'30px'}}
                  >
                  <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{    textAlign: 'left',
                                                                                          color: 'white',
                                                                                          marginLeft: '30px',
                                                                                          fontWeight: 'bold',
                                                                                          fontSize: '16px',
                                                                                          float: 'left',
                                                                                          height: '100%',
                                                                                          verticalAlign: 'middle', }}>
                  <img style={{width:'13%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
              </Grid>
              <Grid
                  item
                  // spacing={8}
                  md={12}
                  lg={12}
                  sm={12}
                  xs={12}
                  // style={{marginBottom:'10px'}}
                  >
                  <h3 style={{ marginTop:'-25px',color:'white', textAlign:'center', fontWeight:'bolder', wordWrap: 'breakWord', whiteSpace: 'normal', fontSize:'17px', fontFamily:'Times New Roman Georgia' }}>
                  {this.context.t('Appointment of Arbitrator')}
              </h3>
              </Grid>
        </Grid>
        </div>
        <ArbitratorAcceptRejectBox/>
        </div>
        )
      }
      else if (this.props.caseData.arbitratorStatus == "true"){
        return(
          <div style={{ height: this.state.height, width: this.state.width, textAlign:'center' }}>
          <div style={{height:'100px', backgroundColor:'#6C0E21', verticalAlign:'center'}}>
          <Grid
          container
          direction="column"
          justifyCo
          spacing={12}
          >
              <Grid
                  item
                  // spacing={8}
                  md={2}
                  lg={2}
                  sm={2}
                  xs={2}
                  style={{marginTop:'30px'}}
                  >
                  <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{    textAlign: 'left',
                                                                                          color: 'white',
                                                                                          marginLeft: '30px',
                                                                                          fontWeight: 'bold',
                                                                                          fontSize: '16px',
                                                                                          float: 'left',
                                                                                          height: '100%',
                                                                                          verticalAlign: 'middle', }}>
                  <img style={{width:'13%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
              </Grid>
              <Grid
                  item
                  // spacing={8}
                  md={12}
                  lg={12}
                  sm={12}
                  xs={12}
                  // style={{marginBottom:'10px'}}
                  >
                  <h3 style={{ marginTop:'-25px',color:'white', textAlign:'center', fontWeight:'bolder', wordWrap: 'breakWord', whiteSpace: 'normal', fontSize:'17px', fontFamily:'Times New Roman Georgia' }}>
                  {this.context.t('Appointment of Arbitrator')}
              </h3>
              </Grid>
        </Grid>
        </div>
        <ArbitratorAppointed caseData={this.props.caseData} claimantArbitratorName={this.props.claimantArbitratorName}/>
        </div>
       
        )
      }
      else{
        return (<div></div>)
      }
    // }
    // else{
    //   return (<div></div>)
    // }
  }
}

// export default withStyles(styles)(ChatBoxMoreInfo);

const mapStateToProps = (state) => {
  return {
    caseId: state.caseInfo.caseId,
    caseData: state.caseInfo.caseData,
    claimantArbitratorName: state.caseInfo.claimantArbitratorName,
    respondentArbitratorName: state.caseInfo.respondentArbitratorName,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    AdminAcceptReject: (caseId, arbitratorId, status) =>
      dispatch(actions.AdminAcceptReject(caseId, arbitratorId, status)),
  };
};

const mapSizesToProps = (sizes) => ({
  isMobile: withSizes.isMobile(sizes),
  isTablet: withSizes.isTablet(sizes),
  isDesktop: withSizes.isDesktop(sizes),
  isGtMobile: withSizes.isGtMobile(sizes),
  isGtTablet: withSizes.isGtTablet(sizes),
  isStTablet: withSizes.isStTablet(sizes),
  isStDesktop: withSizes.isStDesktop(sizes),
  isTabletAndGreater: withSizes.isTabletAndGreater(sizes),
  isTabletAndSmaller: withSizes.isTabletAndSmaller(sizes),
});

ChooseArbitratorForCaseInformation.contextTypes = {
  t: PropTypes.func,
};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withSizes(mapSizesToProps)(withRouter(ChooseArbitratorForCaseInformation)))
);
